module.exports = __webpack_public_path__ + "img/logo.0bab1531.png";